import { makeStyles } from "tss-react/mui";

export const useNWONSubServicePageStyles = makeStyles()((theme) => ({
  ctaButton: {
    marginTop: theme.spacing(4),
  },
}));
